module.exports = __webpack_public_path__ + "img/s2.5a01e33.png";